export const UPDATE_EXTERNAL = 'zola/external/UPDATE_EXTERNAL';
export const PLACED_ORDER = 'zola/external/PLACED_ORDER';
export const CONFIRMED_ORDER = 'zola/external/CONFIRMED_ORDER';
export const CANCELLED_ORDER = 'zola/external/CANCELLED_ORDER';
export const RESET = 'zola/external/RESET';
